import { useEffect } from 'react';
import { calculatePosition } from '../utils';

/**
 * Hook for handling window events (toolbar zoom buttons, presets)
 */
export const useGanttEvents = (chartRef, dateRange, handlePresetChange, smoothZoom) => {
  // Handle zoom events
  useEffect(() => {
    const handleZoomEvent = (e) => {
      if (e.detail.action === 'in') {
        smoothZoom(-100); // Zoom in (negative delta = zoom in)
      } else if (e.detail.action === 'out') {
        smoothZoom(100); // Zoom out (positive delta = zoom out)
      } else if (e.detail.action === 'today') {
        if (!dateRange || !chartRef.current) return;
        const today = new Date();
        const todayPos = calculatePosition(today, dateRange.startDate, dateRange.totalDays);
        const scrollContainer = chartRef.current;
        const timelineWidth = scrollContainer.scrollWidth - 200;
        const scrollTo = (todayPos / 100) * timelineWidth - (scrollContainer.clientWidth / 2) + 200;
        scrollContainer.scrollTo({ left: Math.max(0, scrollTo), behavior: 'smooth' });
      }
    };
    
    window.addEventListener('ganttZoom', handleZoomEvent);
    return () => window.removeEventListener('ganttZoom', handleZoomEvent);
  }, [chartRef, dateRange, smoothZoom]);
  
  // Handle preset events
  useEffect(() => {
    const handlePresetEvent = (e) => {
      const { preset } = e.detail;
      handlePresetChange(preset);
    };
    
    window.addEventListener('ganttPreset', handlePresetEvent);
    return () => window.removeEventListener('ganttPreset', handlePresetEvent);
  }, [handlePresetChange]);
};

export default useGanttEvents;
